<template>
  <v-row class="reverse-sm" align="center">
    <v-col cols="12" md="6">
      <div class="hero-text">

        <!-- Badge de categoria -->
        <div class="hero-badge">
          <v-icon small class="mr-1" color="error">mdi-lightning-bolt</v-icon>
          Sistema completo para Delivery
        </div>

        <h1 class="headline-text mt-3">
          Sistema de Pedidos para Delivery
        </h1>

        <p class="subheadline-text mt-4">
          Automatize os pedidos do seu Delivery com o Cardápio e Comanda Digital ZaperMenu e imprima direto na sua cozinha, com agilidade e sem erros.
        </p>

        <div class="mt-5">
          <CtaButton v-if="showPrice">COMECE AGORA</CtaButton>
          <CtaButton v-else>Quero Saber Mais</CtaButton>
        </div>

      </div>
    </v-col>
    <v-col
      cols="12"
      md="6"
      class="d-flex flex-column align-center position-relative"
    >
      <div class="hero-video">
        <!-- <video
          autoplay
          loop
          muted
          class="video-impressora"
        >
          <source
            :src="require('@/assets/videos/impressora.mp4')"
            type="video/mp4"
          />
        </video> -->

        <!-- <img
          :src="require('@/assets/images/impressora.gif')"
          class="video-impressora"
        /> -->

        <img
          :src="$vuetify.theme.dark
            ? require('@/assets/images/hero-new3.webp')
            : require('@/assets/images/hero-new4.webp')"
          class="hero-img"
          width="auto"
          decoding="async"
          loading="eager"
          fetchpriority="high"
          alt="Sistema de pedidos para delivery"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import CtaButton from "@/components/CtaButton.vue";
  import { mapState } from 'vuex';

  export default {
    name: "Hero",

    components: {
      CtaButton,
    },

    computed: {
      ...mapState([
        'plan',
      ]),

      showPrice() {
        return this.plan.price > 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .hero-text {
    width: 90%;
    margin: 0 auto;

    @media (max-width: 780px) {
      width: 100%;
    }
  }

  /* Badge de categoria */
  .hero-badge {
    display: inline-flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 999px;
    border: 1px solid rgba(244, 6, 18, 0.35);
    background: rgba(244, 6, 18, 0.08);
    font-size: 13px;
    font-weight: 600;
    color: #f40612;
    letter-spacing: 0.02em;
  }

  /* Título */
  .headline-text {
    font-size: 52px;
    font-weight: 700;
    line-height: 1.1;

    background: linear-gradient(
      90deg,
      #f40612 0%,
      #ff4d1a 25%,
      #ffb347 50%,
      #ff4d1a 75%,
      #f40612 100%
    );
    background-size: 250% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: headline-shimmer 4s linear infinite;

    @media (max-width: 780px) {
      font-size: 38px;
    }
  }

  @keyframes headline-shimmer {
    0%   { background-position: 0% center; }
    100% { background-position: 250% center; }
  }

  /* Subtítulo */
  .subheadline-text {
    font-size: 17px;
    font-weight: 400;
    line-height: 1.75;
    color: var(--text-secondary);
    border-left: 3px solid rgba(244, 6, 18, 0.4);
    padding-left: 14px;
    margin: 0;

    @media (max-width: 780px) {
      font-size: 15px;
    }
  }

  .video-impressora {
    height: 350px;
    border-radius: 10px;
    /* background: radial-gradient(circle at 100% 100%, #ffffff 0, #ffffff 3px, transparent 3px) 0% 0% / 8px 8px no-repeat, radial-gradient(circle at 0 100%, #ffffff 0, #ffffff 3px, transparent 3px) 100% 0% / 8px 8px no-repeat, radial-gradient(circle at 100% 0, #ffffff 0, #ffffff 3px, transparent 3px) 0% 100% / 8px 8px no-repeat, radial-gradient(circle at 0 0, #ffffff 0, #ffffff 3px, transparent 3px) 100% 100% / 8px 8px no-repeat, linear-gradient(#ffffff, #ffffff) 50% 50% / calc(100% - 10px) calc(100% - 16px) no-repeat, linear-gradient(#ffffff, #ffffff) 50% 50% / calc(100% - 16px) calc(100% - 10px) no-repeat, linear-gradient(transparent 0%, #f40612 100%);
    border-radius: 8px;
    padding: 9px;
    box-sizing: border-box; */
    box-shadow: 0 0 50px 5px #ff00005e;
    margin-top: 30px;
    @media (min-width: 320px) {
      height: 130px;
    }
    @media (min-width: 375px) {
      height: 180px;
    }
    @media (min-width: 425px) {
      height: 200px;
    }
    @media (min-width: 768px) {
      height: 350px;
    }
  }

  .hero-img {
    /* width: auto preserva proporção — só controla a altura */
    display: block;
    width: auto;
    max-width: 100%;
    border-radius: 10px;
    animation: hero-float 6s ease-in-out infinite;

    /* Mobile: limita altura, largura proporcional */
    @media (max-width: 374px) {
      height: 270px;
    }
    @media (min-width: 375px) and (max-width: 424px) {
      height: 305px;
    }
    @media (min-width: 425px) and (max-width: 767px) {
      height: 340px;
    }

    /* Desktop: deixa crescer naturalmente até o limite da coluna */
    @media (min-width: 768px) {
      height: auto;
      max-height: 560px;
      width: 100%;
      object-fit: contain;
    }
    @media (min-width: 1024px) {
      max-height: 600px;
    }
  }

  @keyframes hero-float {
    0%   { transform: translateY(0px); }
    50%  { transform: translateY(-7px); }
    100% { transform: translateY(0px); }
  }

  .reverse-sm {
    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
  }
</style>
